var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "invasive_service_info" } },
    [
      _c(_setup.RequiresPrimaryConsultationModal),
      _vm._v(" "),
      _c(_setup.ReferralForServiceModal),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }